var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.266 13.389c.709-.153 1.07.84.585 1.38a.146.146 0 01-.08.046c-1.813.35-2.95 1.137-3.688 1.96a6.162 6.162 0 00-.986 1.502c-.28.595.201 1.223.858 1.223h1.356c.14 0 .246.128.22.266C4.435 20.36 4.005 21 3.403 21H.913l-.102-.005c-.503-.051-.882-.477-.8-.988.298-1.819 1.487-5.591 6.255-6.618z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.554 13.139c6.455.281 7.926 4.817 8.26 6.868.09.545-.349.993-.9.993h-16l-.103-.005c-.503-.051-.882-.477-.8-.988.346-2.117 1.902-6.882 8.902-6.882l.64.014zm-.64 1.486c-3.12 0-4.837 1.042-5.83 2.15-.786.874-1.207 1.889-1.43 2.725h14.519c-.223-.836-.644-1.85-1.43-2.726-.994-1.107-2.711-2.149-5.83-2.149z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.913 3c.234 0 .464.018.688.053.491.076.625.67.345 1.08a.906.906 0 01-.82.375 3 3 0 10.001 5.983c.319-.024.64.11.82.374.28.412.146 1.006-.345 1.082A4.5 4.5 0 118.914 3z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.913 3a4.5 4.5 0 11-3.783 2.064l.05-.08.127-.176A4.494 4.494 0 0114.913 3zm0 1.5a2.99 2.99 0 00-2.086.845c-.012.01-.023.022-.035.034l-.194.213c-.061.074-.12.15-.173.23l-.15.248-.126.262a2.981 2.981 0 00-.22.861l-.012.153a3.037 3.037 0 00.022.544l.008.067A3.001 3.001 0 1014.913 4.5z",
    fill: "currentColor"
  })));
}
SvgSocial.displayName = 'Social';
export default SvgSocial;